import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Target } from "lucide-react";

interface AssignmentData {
  id: string;
  name: string;
  state: string;
  type: string;
  description: string | null;
  completionPercentage: number | null;
  insertedAt: string;
  updatedAt: string;
}

interface OverviewTabProps {
  assignmentData: AssignmentData;
  formatDate: (date: Date | string | null) => string;
}

export function OverviewTab({ assignmentData, formatDate }: OverviewTabProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Assignment Details */}
      <Card className="lg:col-span-2">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Target className="h-5 w-5" />
            Assignment Details
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Status</p>
              <Badge variant="outline" className="mt-1">
                {assignmentData.state}
              </Badge>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Type</p>
              <p className="mt-1">{assignmentData.type}</p>
            </div>
            {/* Business Unit - commented out: businessUnit relationship not loaded from getAssignmentById */}
            {/* <div>
              <p className="text-sm font-medium text-muted-foreground">Business Unit</p>
              <p className="mt-1">{assignmentData.businessUnit || "Not assigned"}</p>
            </div> */}
            {/* Start Date - commented out: startDate not available from getAssignmentById */}
            {/* <div>
              <p className="text-sm font-medium text-muted-foreground">Start Date</p>
              <p className="mt-1">{formatDate(assignmentData.startDate)}</p>
            </div> */}
            {/* End Date - commented out: endDate not available from getAssignmentById */}
            {/* <div>
              <p className="text-sm font-medium text-muted-foreground">End Date</p>
              <p className="mt-1">{formatDate(assignmentData.endDate)}</p>
            </div> */}
            <div>
              <p className="text-sm font-medium text-muted-foreground">Created At</p>
              <p className="mt-1">{formatDate(assignmentData.insertedAt)}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-muted-foreground">Last Updated</p>
              <p className="mt-1">{formatDate(assignmentData.updatedAt)}</p>
            </div>
          </div>

          {/* Risk Assessment - commented out: riskLikelihood, impact, inherentRisk not available from getAssignmentById */}
          {/* <Separator />

          <div>
            <p className="text-sm font-medium text-muted-foreground mb-2">Risk Assessment</p>
            <div className="grid grid-cols-3 gap-3">
              <div className="text-center p-3 border rounded-lg">
                <p className="text-xs text-muted-foreground">Likelihood</p>
                <Badge className={`mt-1 ${getRiskColor(assignmentData.requirements.riskLikelihood)}`}>
                  {assignmentData.requirements.riskLikelihood}
                </Badge>
              </div>
              <div className="text-center p-3 border rounded-lg">
                <p className="text-xs text-muted-foreground">Impact</p>
                <Badge className={`mt-1 ${getRiskColor(assignmentData.requirements.impact)}`}>
                  {assignmentData.requirements.impact}
                </Badge>
              </div>
              <div className="text-center p-3 border rounded-lg">
                <p className="text-xs text-muted-foreground">Inherent Risk</p>
                <Badge className={`mt-1 ${getRiskColor(assignmentData.requirements.inherentRisk)}`}>
                  {assignmentData.requirements.inherentRisk}
                </Badge>
              </div>
            </div>
          </div> */}
        </CardContent>
      </Card>

      {/* Team Members */}
      {/* Team Members Card - commented out: teamMembers not available from getAssignmentById */}
      {/* <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            Team Members
          </CardTitle>
          <CardDescription>Assigned team for this assignment</CardDescription>
        </CardHeader>
        <CardContent>
          {isLoadingUsers ? (
            <div className="flex items-center gap-2">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
              <span className="text-sm">Loading...</span>
            </div>
          ) : (
            <div className="space-y-3">
              {assignmentData.teamMembers.map((member) => (
                <div key={member.id} className="flex items-center gap-3 p-2 rounded-lg hover:bg-muted/50">
                  <Avatar className="h-8 w-8">
                    <AvatarImage src={member.avatar} alt={member.name} />
                    <AvatarFallback>{member.name.substring(0, 2).toUpperCase()}</AvatarFallback>
                  </Avatar>
                  <div className="flex-1">
                    <p className="font-medium text-sm">{member.name}</p>
                    <p className="text-xs text-muted-foreground">{member.role}</p>
                  </div>
                  <Button variant="ghost" size="sm">
                    <MessageSquare className="h-4 w-4" />
                  </Button>
                </div>
              ))}
              <Button variant="outline" size="sm" className="w-full" onClick={() => setIsAddTeamMemberModalOpen(true)}>
                <Plus className="h-4 w-4 mr-2" />
                Add Member
              </Button>
            </div>
          )}
        </CardContent>
      </Card> */}
    </div>
  );
}
